/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData from './EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData';
import MaterialProperty from './MaterialProperty';

/**
 * The EventsControllerDtoEventInvitationPartnerDetailResponse model module.
 * @module model/EventsControllerDtoEventInvitationPartnerDetailResponse
 * @version 1.0
 */
class EventsControllerDtoEventInvitationPartnerDetailResponse {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationPartnerDetailResponse</code>.
     * @alias module:model/EventsControllerDtoEventInvitationPartnerDetailResponse
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationPartnerDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationPartnerDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerDetailResponse} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationPartnerDetailResponse} The populated <code>EventsControllerDtoEventInvitationPartnerDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationPartnerDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('partnerAccountNo')) {
                obj['partnerAccountNo'] = ApiClient.convertToType(data['partnerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('invCode')) {
                obj['invCode'] = ApiClient.convertToType(data['invCode'], 'String');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('list')) {
                obj['list'] = ApiClient.convertToType(data['list'], [EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationPartnerDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationPartnerDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['invCode'] && !(typeof data['invCode'] === 'string' || data['invCode'] instanceof String)) {
            throw new Error("Expected the field `invCode` to be a primitive type in the JSON string but got " + data['invCode']);
        }
        if (data['list']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['list'])) {
                throw new Error("Expected the field `list` to be an array in the JSON data but got " + data['list']);
            }
            // validate the optional field `list` (array)
            for (const item of data['list']) {
                EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} partnerAccountNo
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['partnerAccountNo'] = undefined;

/**
 * @member {String} email
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['email'] = undefined;

/**
 * @member {String} invCode
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['invCode'] = undefined;

/**
 * @member {Boolean} enabled
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['enabled'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['createdAt'] = undefined;

/**
 * @member {Array.<module:model/EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData>} list
 */
EventsControllerDtoEventInvitationPartnerDetailResponse.prototype['list'] = undefined;






export default EventsControllerDtoEventInvitationPartnerDetailResponse;

